import type { Bag as JetBag, Host, Network, Random } from '@jet/environment';
import { ObjectGraph } from '@jet/environment/dependencies';
// import {
//     Bag,
//     type Bundle,
//     type Locale,
//     Localizer,
//     type LoggerFactory,
// } from './dependencies';
import { Metrics } from './metrics';
import { Bag } from './dependencies/bag';
import type { Locale } from './dependencies/locale';
import type { LoggerFactory } from './dependencies/logger';
import type { Bundle } from './dependencies/bundle';
import type { Persistence } from './utilities/storage/Persistence';
import type { SubscriptionStatusCoordinator } from './dependencies/subscription-status-coordinator';
import { Localizer } from './dependencies/localization';
import { ObjectGraphType } from './dependencies/object-graph-type';
import { Storage } from './utilities/storage/Storage';
import { Features, type HostFeatures } from './dependencies/features';

// TODO:  move this all to dependencies directory, call it host-dependencies
interface Dependencies {
    net: Network;
    host: Host;
    locale: Locale;
    loggerFactory: LoggerFactory;
    bundle: Bundle;
    bag: JetBag;
    features?: HostFeatures;
    random: Random;
    persistence: Persistence;
    subscriptionStatusCoordinator: SubscriptionStatusCoordinator;
}

function makeDependencies(hostDependencies: Dependencies): ObjectGraph {
    // BAILEY
    // const logger = hostDependencies.loggerFactory.build();
    const logger = hostDependencies.loggerFactory.build('logger');

    const dependencyObjectGraph = new ObjectGraph('Dependency Graph')
        .adding(ObjectGraphType.host, hostDependencies.host)
        .adding(ObjectGraphType.bag, new Bag(hostDependencies.bag))
        .adding(ObjectGraphType.network, hostDependencies.net)
        .adding(ObjectGraphType.bundle, hostDependencies.bundle)
        .adding(ObjectGraphType.locale, hostDependencies.locale)
        .adding(ObjectGraphType.logger, logger)
        .adding(ObjectGraphType.loggerFactory, hostDependencies.loggerFactory)
        .adding(ObjectGraphType.random, hostDependencies.random)
        .adding(
            ObjectGraphType.subscriptionStatusCoordinator,
            hostDependencies.subscriptionStatusCoordinator,
        )
        .adding(
            ObjectGraphType.features,
            new Features(hostDependencies.features ?? {}),
        )
        .adding(ObjectGraphType.metrics, new Metrics())
        .adding(
            ObjectGraphType.storage,
            new Storage(hostDependencies.persistence),
        );

    // i18n
    const localization = new Localizer(dependencyObjectGraph);
    localization.loadStrings();

    return dependencyObjectGraph.adding(
        ObjectGraphType.localization,
        localization,
    );
}

export { makeDependencies, ObjectGraphType };

export type { Dependencies };
